import { defineMessages } from 'react-intl'

const scope = `procurify.components.ApprovalReminderForm`

export default defineMessages({
  recipientLabel: {
    id: `${scope}.recipientLabel`,
    defaultMessage: 'Recipient:',
  },
  commentLabel: {
    id: `${scope}.commentLabel`,
    defaultMessage: 'Comment (optional)',
  },
  commentPlaceholder: {
    id: `${scope}.commentPlaceholder`,
    defaultMessage: 'Hi, I would like to know...',
  },
  cancelButtonText: {
    id: `${scope}.cancelButtonText`,
    defaultMessage: 'Cancel',
  },
  sendReminderButtonText: {
    id: `${scope}.sendReminderButtonText`,
    defaultMessage: 'Send reminder',
  },
  modalTitle: {
    id: `${scope}.modalTitle`,
    defaultMessage: 'Send a reminder',
  },
})
